<div id="wrapper cp-open" class="trova-atm">
  <div id="wrapper" class="trova-atm">
    <div class="focusLayer"></div>
    <!-- NUOVA LIB -->
    <!-- map display -->
    <google-map #map [zoom]="zoomLevel" [center]="{lat: latitude, lng: longitude}" [options]="matOptions"
      (mapReady)="onMapReady($event)">
    
      <!-- for multiple markers -->
      <ng-container *ngIf="showAgencyMarkers">
        <map-marker *ngFor="let agency of agencyList" [position]="{lat: agency.latitude, lng: agency.longitude}"
          [options]="multiMarkerOptions"></map-marker>
      </ng-container>
    
    
      <!-- for multiple markers -->
      <ng-container *ngIf="showAtmMarkers">
        <map-marker #marker *ngFor="let atm of filteredAtmList" (mapClick)="getAtmDetail(atm,target)"
          [position]="{lat: atm.latitudeDecimalDegrees, lng: atm.longitudeDecimalDegrees}"
          [options]="multiMarkerOptions"></map-marker>
      </ng-container>
    
      <!-- Single Agency Marker on click of detail -->
      <map-marker *ngIf="showAgencyDetail" [position]="{lat: agencyDetail.latitude, lng: agencyDetail.longitude}"
        [options]="singleMarkerOptions"></map-marker>
    
      <!-- Single ATM Marker on click of detail -->
      <map-marker *ngIf="showAtmDetail"
        [position]="{lat: atmDetail.latitudeDecimalDegrees, lng: atmDetail.longitudeDecimalDegrees}"
        [options]="singleMarkerOptions"></map-marker>
    </google-map>

    <div class="container-card">
      <div id="over_map" #target>
        <div class="floating-card no-margin">
          <div class="fd-card-above">
            <fnd-card customCssClass="posizioneBox mdl-shadow--2dp cardSearch" [busy]="busyCard || busyCardReverseGeocoding || busyCardATMByPosition">
              <div class="bh-bg"></div>

              <fnd-card-body *ngIf="serviceErrorMessage!== null && serviceErrorMessage!== undefined">
                <app-error-handling [errorMessage]="serviceErrorMessage"></app-error-handling>
              </fnd-card-body>

              <fnd-tabset *ngIf="!showAgencyDetail && !showAtmDetail">
                <!-- Agency tab -->
                <fnd-tab *ngIf="showAgenciesTab" [title]="agenzieTabLabel" [showHideClass]="show" class="fd-ctn-frm">
                  <h3 class="fd-subtitle">{{agenzieHeader}}</h3>

                  <form #agencyForm="ngForm">
                    <fnd-select-input name="agencyRegion" label="{{regionSelectLabel}}" [options]="regionList"
                      [(ngModel)]="agencyRegion" #agencyRegionInput="ngModel" hint="" [value]="agencyRegion"
                      [error]="agencyRegionInput.invalid && (agencyRegionInput.dirty || agencyRegionInput.touched)"
                      required>
                      <fnd-validation *ngIf="agencyRegionInput.invalid && (agencyRegionInput.dirty || agencyRegionInput.touched)">
                        <span *ngIf="agencyRegionInput.errors.required">{{valueRequiredMessage}}</span>
                      </fnd-validation>
                    </fnd-select-input>

                    <fnd-button id="search" [label]="searchButtonLabel" [primary]="true" (action)="searchAgencies()"></fnd-button>
                    <br>
                    <br>
                    <fnd-button id="currentPosition" showIcon="true" icon="gps_fixed" [label]="getCurrentLocationLabel"
                      [primary]="false" (action)="searchAgenciesWithCurrentPosition()"></fnd-button>
                    <br>
                    <br>
                  </form>
                </fnd-tab>

                <!-- ATM tab -->
                <fnd-tab [title]="atmTabLabel" class="fd-ctn-frm">
                  <h3 class="atm-detail-subtitle">{{atmHeader}}</h3>

                  <form #atmForm="ngForm">
                    <app-select-atm name="atmRegion" class="region" label="{{regionSelectLabel}}" [options]="regionList"
                      [(ngModel)]="atmRegion" (valueFocus)="activateFocus($event)" (valueBlur)="activateBlur($event)"
                      #atmRegionInput="ngModel" hint="" [value]="atmRegion"
                      (valueChange)="fillProvinceList($event.value, true)"
                      [error]="atmRegionInput.invalid && (atmRegionInput.dirty || atmRegionInput.touched)" required>
                      <fnd-validation *ngIf="atmRegionInput.invalid && (atmRegionInput.dirty || atmRegionInput.touched)">
                        <span *ngIf="atmRegionInput.errors.required">{{valueRequiredMessage}}</span>
                      </fnd-validation>
                    </app-select-atm>

                    <h3 class="atm-detail-subtitle">{{provinceHeader}}</h3>
                    <app-select-atm name="atmProvince" label="{{provinceSelectLabel}}" [options]="provinceList"
                      [(ngModel)]="atmProvince" #atmProvinceInput="ngModel" hint="" (valueFocus)="activateFocus($event)"
                      (valueBlur)="activateBlur($event)" [value]="atmProvince"
                      (valueChange)="provinceSelected($event.value, $event.label)"
                      [error]="atmProvinceInput.invalid && (atmProvinceInput.dirty || atmProvinceInput.touched)"
                      required>
                      <fnd-validation *ngIf="atmProvinceInput.invalid && (atmProvinceInput.dirty || atmProvinceInput.touched)">
                        <span *ngIf="atmProvinceInput.errors.required">{{valueRequiredMessage}}</span>
                      </fnd-validation>
                    </app-select-atm>

                    <fnd-button id="currentPosition" showIcon="true" icon="gps_fixed" [label]="getCurrentLocationLabel"
                      [primary]="false" (action)="searchAtmWithCurrentPosition()"></fnd-button>
                    <br>
                    <br>
                  </form>
                </fnd-tab>
              </fnd-tabset>

              <div class="fd-ctn-frm" *ngIf="showAgencyDetail">
                <fnd-card-header [title]="goBackLabel" id="detail-screen">
                  <fnd-button customCssClass="mdl-button fd-secondary" showIcon="true" icon="keyboard_arrow_left" (action)="backToTabsAgency()"></fnd-button>
                </fnd-card-header>

                <fnd-card-body>
                  <h2 class="fd-subtitle set-color">{{agencyDetail.name}}</h2>
                  <h3 class="fd-subtitle">{{agencyDetail.shortAddress}}</h3>
                  <br>
                  <fnd-button id="lookOnGoogle" showIcon="true" icon="location_on" [label]="lookOnGoogleMapLabel"
                    [primary]="false" (action)="goToGoogleMapsAgency(agencyDetail)"></fnd-button>
                </fnd-card-body>
              </div>

              <div class="fd-ctn-frm atm-detail" *ngIf="showAtmDetail">
                <fnd-card-header [title]="goBackLabel" id="detail-screen" (click)="backToTabsAtm()">
                  <fnd-button customCssClass="mdl-button fd-secondary" showIcon="true" icon="keyboard_arrow_left"
                    (action)="backToTabsAtm()"></fnd-button>
                </fnd-card-header>

                <fnd-card-body>
                  <strong class="set-title-color capitalize" style="font-size:17px !important;">{{atmDetail.placeDescription | lowercase}}</strong>
                  <h2 class="capitalize address">{{atmDetail.addressDescription | lowercase}} - {{this.printProvince | uppercase}}</h2>
                  <h3 class="paddingTop set-bolder facitSemiBold" style="font-size:16px !important;">{{serviceLabel}}</h3>
                  <h3 class="set-dark-color services-list" *ngFor="let service of atmDetail.services">
                    <span class="capitalize address">{{service}}</span>
                  </h3>
                  <br>
                  <fnd-button id="lookOnGoogle" showIcon="true" icon="&#58727;" [label]="lookOnGoogleMapLabel"
                    [primary]="false" (action)="goToGoogleMapsAtm(atmDetail)">
                  </fnd-button>
                </fnd-card-body>
              </div>
            </fnd-card>
          </div> <!-- fine floating-card no-margin -->
        </div>
        <!--fine fine card above  -->
      </div>
      <!--fine container card -->
    </div>
    <!--fine container-card -->
    <h3 *ngIf="showAtmMarkers || showAtmList || showAtmGrid" class="fd-subtitle set-padding-total-result-display fill-width top-result">
      <span class="result-label">{{resultsFoundLabel}}: <b>{{totalATMsFound}}</b></span>
      <span class="align-buttons-right">
        <fnd-button customCssClass="fd-generic-info-modal table-grid-switch" showIcon="true" icon="view_module"
          (action)="switchToAtmList()" [ngClass]="showAtmGrid ? 'color-black': 'color-grey'"></fnd-button>
        <fnd-button customCssClass="fd-generic-info-modal table-grid-switch" showIcon="true" icon="view_list"
          (action)="switchToAtmGrid()" [ngClass]="showAtmList ? 'color-black': 'color-grey'"></fnd-button>
      </span>
    </h3>

    <h3 *ngIf="showAgencyMarkers || showAgencyGrid || showAgencyList" class="fd-subtitle set-padding-total-result-display fill-width top-result">
      <span class="result-label">{{resultsFoundLabel}}: <b>{{totalAgenciesFound}}</b></span>
      <span class="align-buttons-right">
        <fnd-button customCssClass="fd-generic-info-modal" showIcon="true" icon="view_module"
          (action)="switchToAgencyList()" [ngClass]="showAgencyGrid ? 'color-black': 'color-grey'"></fnd-button>
        <fnd-button customCssClass="fd-generic-info-modal" showIcon="true" icon="view_list"
          (action)="switchToAgencyGrid()" [ngClass]="showAgencyList ? 'color-black': 'color-grey'"></fnd-button>
      </span>
    </h3>

    <div *ngIf="showAgencyGrid">
      <div class="mdl-grid set-padding-result-display">
        <div class="full-width">
          <fnd-card customCssClass="mdl-shadow--2dp">
            <fnd-card-header [title]="agencyResultTitle"></fnd-card-header>

            <fnd-card-body>
              <div class="content-grid mdl-grid">
                <div *ngFor="let agency of displayGrid" class="grid-display">
                  <fnd-card-body>
                    <h2 class="fd-subtitle capitalize">{{agency.name}}</h2>
                    <h3 class="fd-txt set-bold capitalize">{{agency.shortAddress}}</h3>
                    <fnd-button [label]="detailButtonLabel" [primary]="true" (action)="getAgencyDetail(agency)"></fnd-button>
                  </fnd-card-body>
                </div>
              </div>
            </fnd-card-body>

            <fnd-card-footer customCssClass="mdl-card--border">
              <!-- Pagination -->
              <div class="fd-pagination noselect" *ngIf="pager.pages && pager.pages.length && pager.totalPages>1">
                <span>{{pager.currentPage}}</span>

                <ng-container *ngIf="pager.currentPage==1; else elseBlock">
                  <a>
                    <i class="material-icons noselect" (click)="setGridPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>

                </ng-container>
                <ng-template #elseBlock>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setGridPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-template>

                <ng-container *ngIf="pager.currentPage==pager.totalPages  else elseBlockNext">
                  <a class="pagination-hidden-arrow">
                    <i class="material-icons noselect" (click)="setGridPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-container>
                <ng-template #elseBlockNext>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setGridPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-template>
              </div>
            </fnd-card-footer>
          </fnd-card>
        </div>
      </div>
    </div>

    <div *ngIf="showAgencyList">
      <div class="mdl-grid set-padding-result-display">
        <div class="full-width">
          <fnd-card customCssClass="mdl-shadow--2dp">
            <fnd-card-header [title]="agencyResultTitle"></fnd-card-header>

            <fnd-card-body class="fd-ctn-data fd-no-spacer fd-ct" customCssClass="no-padding">
              <div *ngIf="displayList.length > 0" class="mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col-desktop no-padding no-margin full-width">
                <table aria-describedby="agency-list" class="mdl-data-table mdl-js-data-table">
                  <tbody>
                    <tr>
                      <th></th>
                    </tr>
                    <tr *ngFor="let agency of displayList">
                      <td class="mdl-data-table__cell--non-numeric"><strong class="set-color">{{agency.name}}</strong></td>
                      <td class="mdl-data-table__cell--non-numeric set-dark-color">{{agency.shortAddress}}</td>
                      <td class="mdl-data-table__cell--non-numeric detail-button">
                        <fnd-button [label]="detailButtonLabel" [primary]="true" (action)="getAgencyDetail(agency)"></fnd-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fnd-card-body>

            <fnd-card-footer customCssClass="mdl-card--border">
              <!-- Pagination -->
              <div class="fd-pagination noselect" *ngIf="pager.pages && pager.pages.length && pager.totalPages>1">
                <span>{{pager.currentPage}}</span>

                <ng-container *ngIf="pager.currentPage==1; else elseBlock">
                  <a>
                    <i class="material-icons noselect" (click)="setPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-container>
                <ng-template #elseBlock>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-template>

                <ng-container *ngIf="pager.currentPage==pager.totalPages; else elseBlockNext">
                  <a class="pagination-hidden-arrow">
                    <i class="material-icons noselect" (click)="setPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-container>
                <ng-template #elseBlockNext>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-template>
              </div>
            </fnd-card-footer>
          </fnd-card>
        </div>
      </div>
    </div>

    <div *ngIf="showAtmGrid && !listATMEmpty">
      <div class="mdl-grid set-padding-result-display">
        <div class="full-width">
          <fnd-card customCssClass="mdl-shadow--2dp">
            <fnd-card-header title="{{atmResultTitle}}"></fnd-card-header>

            <fnd-card-body>
              <div class="content-grid mdl-grid">
                <div *ngFor="let atm of displayGrid" class="grid-display">
                  <fnd-card-body>
                    <h2 class="fd-subtitle capitalize correctPadding">{{atm.placeDescription | lowercase}}</h2>
                    <p class="fd-txt capitalize">{{atm.addressDescription | lowercase}} - {{this.printProvince | uppercase}}</p>
                    <fnd-button [label]="detailButtonLabel" [primary]="true" (action)="getAtmDetail(atm,target)"></fnd-button>
                  </fnd-card-body>
                </div>
              </div>
            </fnd-card-body>

            <fnd-card-menu>
              <!-- Filter Button-->
              <fnd-button showIcon="true" icon="filter_list" customCssClass="fd-info-modal" (action)="openButtonModal()"></fnd-button>
            </fnd-card-menu>

            <fnd-card-footer customCssClass="mdl-card--border">
              <!-- Pagination -->
              <div class="fd-pagination noselect" *ngIf="pager.pages && pager.pages.length && pager.totalPages>1">
                <span>{{pager.currentPage}}</span>

                <ng-container *ngIf="pager.currentPage==1; else elseBlock">
                  <a>
                    <i class="material-icons noselect" (click)="setGridPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-container>
                <ng-template #elseBlock>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setGridPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-template>

                <ng-container *ngIf="pager.currentPage==pager.totalPages; else elseBlockNext">
                  <a class="pagination-hidden-arrow">
                    <i class="material-icons noselect" (click)="setGridPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-container>
                <ng-template #elseBlockNext>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setGridPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-template>
              </div>
            </fnd-card-footer>
          </fnd-card>
        </div>
      </div>
    </div>

    <div *ngIf="showAtmList && !listATMEmpty">
      <div class="mdl-grid set-padding-result-display-atm">
        <div class="full-width">
          <fnd-card customCssClass="mdl-shadow--2dp">
            <fnd-card-header class="card-header-title-width" [title]="atmResultTitle"></fnd-card-header>

            <fnd-card-body class="fd-ctn-data fd-no-spacer fd-ct" customCssClass="no-padding">
              <div *ngIf="displayList.length > 0" class="mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col-desktop no-padding no-margin full-width">
                <table aria-describedby="atm list" class="mdl-data-table mdl-js-data-table">
                  <tbody>
                    <tr>
                      <th></th>
                    </tr>
                    <tr *ngFor="let atm of displayList" class="list-display">
                      <td class="mdl-data-table__cell--non-numeric first-column">
                        <span class="set-bold set-color capitalize name-description">{{atm.placeDescription | lowercase}}</span>
                        <span class="set-dark-color capitalize addressDescription">{{atm.addressDescription | lowercase}} - {{this.printProvince | uppercase}}</span>
                        <div class="mdl-data-table__cell--non-numeric detail-button"></div>
                      </td>
                      <td class="mdl-data-table__cell--non-numeric detail-button">
                        <fnd-button [label]="detailButtonLabel" [primary]="true" (action)="getAtmDetail(atm,target)"
                          showIcon="true" icon="arrow_forward" customCssClass="arrow-detail-button"></fnd-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fnd-card-body>

            <fnd-card-menu>
              <!-- Filter Button-->
              <fnd-button showIcon="true" icon="filter_list" customCssClass="fd-info-modal margin-left-filter" (action)="openButtonModal()"></fnd-button>
            </fnd-card-menu>

            <fnd-card-footer *ngIf="pager.pages && pager.pages.length && pager.totalPages>1" customCssClass="mdl-card--border">
              <!-- Pagination -->
              <div class="fd-pagination noselect" *ngIf="pager.pages && pager.pages.length && pager.totalPages>1">
                <span>{{pager.currentPage}}</span>

                <ng-container *ngIf="pager.currentPage==1; else elseBlock">
                  <a>
                    <i class="material-icons noselect" (click)="setPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-container>
                <ng-template #elseBlock>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setPage(pager.currentPage - 1, paginationContext)">keyboard_arrow_left</i>
                  </a>
                </ng-template>

                <ng-container *ngIf="pager.currentPage==pager.totalPages; else elseBlockNext">
                  <a class="pagination-hidden-arrow">
                    <i class="material-icons noselect" (click)="setPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-container>
                <ng-template #elseBlockNext>
                  <a>
                    <i class="material-icons noselect pointer" (click)="setPage(pager.currentPage + 1, paginationContext)">keyboard_arrow_right</i>
                  </a>
                </ng-template>
              </div>
            </fnd-card-footer>

          </fnd-card>
        </div>
      </div>
    </div>

    <div *ngIf="listATMEmpty">
      <div class="mdl-grid set-padding-result-display-atm">
        <div class="full-width">
          <fnd-card customCssClass="mdl-shadow--2dp">
            <fnd-card-body class="fd-ctn-data fd-no-spacer fd-ct" customCssClass="no-padding">
              <div class="mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col-desktop no-padding no-margin full-width">

                <table aria-describedby="lista-vuota" class="mdl-data-table mdl-js-data-table">
                  <tbody>
                    <tr>
                      <th></th>
                    </tr>
                    <tr>
                      <td class="mdl-data-table__cell--non-numeric set-dark-color" style="text-align: center; font-size:21px;">
                        <strong>Lista Vuota</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fnd-card-body>

            <fnd-card-footer customCssClass="mdl-card--border"></fnd-card-footer>
          </fnd-card>
        </div>
      </div>
    </div>
    <!--fine lista vuota-->

    <app-modal [modalId]="'atmFilter'" class="atmFilter mdl-dialog">
      <form #filterForm="ngForm" (ngSubmit)="closeButtonModal(); filterATMList()">
        <!-- HEADER -->
        <div class="mdl-dialog__title bkg">
          <fnd-button customCssClass="dialog-header-filter close-icon fd-generic-info-modal" showIcon="true"
            icon="close" (action)="closeButtonModal(filterForm.value)"></fnd-button>
          <fnd-button label="{{filterLabel}}" customCssClass="fd-primary mdl-js-ripple-effect" class="filter-button"
            [primary]="false" buttonType="submit"></fnd-button>
          <h2 class="dialog-header-filter">{{filterByServiceLabel}}</h2>
        </div>

        <!-- MODAL CONTENT -->
        <div class="fd-ctn-frm pTop">
          <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--6-col mdl-cell--12-col-phone">
              <fnd-checkbox-group>
                <fnd-checkbox-input *ngFor="let service of services; let i=index" name="service_{{i}}"
                  label="{{service.label}}" (change)="onCheckboxToggle(service)"></fnd-checkbox-input>
              </fnd-checkbox-group>
            </div>
          </div>
        </div>
      </form>
    </app-modal>
  </div>
</div>